<template>
	<v-sheet style="min-height:100%" color="primary">
		<v-container>
		  <router-view ref="component">
		  	<!-- Componente asociado a ruta -->
		  </router-view>
			<check-version
				@entendido="onAceptarAdvertenciaVersion"
			/>
		</v-container>
	</v-sheet>
</template>

<script>

import CheckVersion from '@/components/CheckVersion';


export default {
	name: 'PublicoView',
	components: {
		CheckVersion
	},
	methods:{
		onAceptarAdvertenciaVersion(){
			
		}
	}
};
</script>
